import React from 'react';
import { withRouter } from 'react-router-dom';
import UserListItem from './user-list-two';
import qs from "qs";


const UserListTransform = ({ title, users, type = "classmates", history, identity = "students",onRemove }) => {

    const host = qs.parse(history.location.search, { ignoreQueryPrefix: true });

    const onItemSelected = (item) => {
        if (identity === "teacher") {
            history.push(`/mine?pid=${item.id}&cid=${host.id}`);
        } else {
            history.push(`/mine?pid=${item.id}`);
        }
    }

    return (
        <UserListItem 
            title={title}
            data={users}
            type={type}
            identity={identity}
            history={history}
            onItemSelected={onItemSelected}
            onRemove={onRemove}
        />
    );
}

export default withRouter(UserListTransform);
